import { CommonModule } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { AccountRoutingModule } from './account-routing.module'
import { AccountStatusInterceptor } from './shared/account-status.interceptor'

@NgModule({
  declarations: [],
  imports: [CommonModule, AccountRoutingModule],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AccountStatusInterceptor, multi: true }],
})
export class AccountModule {}
